import React from 'react';
//Components
import moment from 'moment';
import OutboundEmailsOptions from './OutboundEmailsOptions.jsx';
import OutboundEmailsSummary from './OutboundEmailsSummary.jsx';
import Loader from '../../../../components/loader.jsx';
import {dateTimeFormats} from 'helpers/constants';
import {FormattedMessage} from 'react-intl';

import ReportApi from '../../../../../api/report.jsx';

class OutboundEmails extends React.Component {
  state = {
    data: [],
    filters: [],
    loaded: true,
    showNoDataMessage: false,
  };

  componentWillMount() {
    let date = new Date();
    let filters = {
      dateFrom: moment(new Date(date.setMonth(date.getMonth() - 1))),
      dateTo: moment(new Date()),
      store: 0,
    };

    this.setState({
      filters: filters,
    });
  }

  updateReportData = (dateFrom, dateTo, branch) => {
    let filters = {
      dateFrom: dateFrom,
      dateTo: dateTo,
      branch: branch,
    };

    this.setState({
      loaded: false,
    });
    ReportApi.getOutboundEmailsSummary(dateFrom, dateTo, branch)
            .then(res => {
              this.setState({
                data: res,
                filters: filters,
                loaded: true,
                showNoDataMessage: false,
              });
              if(!Object.keys(res).length) {
                this.setState({loaded: true,showNoDataMessage: true});
              }
            }).catch((e) => {
              console.log(e);
              this.setState({loaded: true,showNoDataMessage: true});
            });
  };

  render() {
    return (
      <div className="report-container">
        <span>
          <FormattedMessage id="reports.outbound.emails.description" />
        </span>
        <OutboundEmailsOptions updateReportData={this.updateReportData} branches={this.props.branches} defaultFilters={this.state.filters} />
        <Loader loaded={this.state.loaded}>
          <OutboundEmailsSummary data={this.state.data} filters={this.state.filters} showNoDataMessage={this.state.showNoDataMessage}/>
        </Loader>
      </div>
    );
  }
}

export default OutboundEmails;
